<!--
  Aspedia VueJS Helper Component
  *=====
  Import Name:  nav-menu
  Name:         NavMenu
  Version:      1
  Date:         2018-03-13
  Author:       Christian Dale <cdale@aspedia.net>

  Description:      Generic navigation menu with dropdown support for i.e. Top Menu.
  Default Data:     N/A
  Component IMG:    N/A
  Ancestor:         N/A
  Available To:     N/A
  Builder Visible:  False
  Version History:
    1    2018-03-13    Christian Dale <cdale@aspedia.net>   Initial revision of the Tree Component.
  *=====
-->

<template>
  <nav
    v-bind="navAttributes"
    role="navigation"
  >
    <tree-view
      :model="model"
      :root-attributes="rootAttributes"
      :render-root-child-tag="false"
      :parent-attributes="parentAttributes"
      :render-child-tag="false"
      root-tag="b-nav"
      parent-tag="b-nav-item-dropdown"
    >
      <nav-menu-item
        slot-scope="item"
        :item="item.item"
        :depth="item.depth"
      />
    </tree-view>
  </nav>
</template>

<script>
import {TreeView} from 'components/helpers'
import NavMenuItem from './nav-menu-item'

export default {
  name: 'nav-menu',
  components: {
    NavMenuItem,
    'tree-view': TreeView,
    'nav-menu-item': NavMenuItem
  },
  props: {
    menuName: {
      type: String,
      default: ''
    },
    attributes: {
      type: Array,
      required: false,
      default: function() { return [] }
    },
    rootClass: {
      type: String,
      required: false,
      default: ''
    }
  },
  data() {
    return {
      model: []
    }
  },
  computed: {
    navAttributes: function() {
      return this.attributes
    },
    rootAttributes: function() {
      let classes = []
      if (this.rootClass !== '') {
        classes.push(this.rootClass)
      }

      return [{class: classes}]
    }
  },
  mounted: function() {
    this.$aspediaLoader.getMenu(this.menuName,
      {
        cache: {
          max_age: 30 * 86400,
          timeout: 30 * 86400
        }
      })
      .then(response => {
        // JSON responses are automatically parsed.
        this.model = response
      })
      .catch((e) => {
        applogger.log('Could not retrieve menu:' + this.menuName)
      })
  },
  methods: {
    parentAttributes: function(model) {
      return [{text: model.title}]
    }
  }
}
</script>

<style scoped>

</style>
